import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { filter } from "rxjs/operators";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";
import { IQuote } from "libraries/hotel/models/quote";
import { ICheckboxFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { BtnStyleTypes } from "libraries/ui_button/btn.component";
import { FormControl, FormGroup } from "@angular/forms";
import { Yii } from "libraries/interfaces/Yii";
export enum IaqoboHotelPermission {
    IQBH_TERMSOFUSE_SHOW = "iqbh.termsOfUse.show",
}
@Component({
    selector: 'terms-of-use-checkbox',
    template: `
        <div *ngIf="isTermsOfUseShown" class="terms-of-use">
            <checkbox-field [fieldConfig]="checkboxFieldConfig"
                            (onChange)="updateAcceptation($event)"></checkbox-field>
            <div class="consulter actionLink">
                (
                <btn [type]="btnStyleTypes.actionLink"
                     (onClick)="goToUrl()"
                     value="consulter"></btn>
                )
            </div>
        </div>
    `,
    styles: [`

        :host {
            display: inline-block;
            margin-right: 0.75rem;
        }

        .consulter {
            font-size: 1rem;
            vertical-align: text-top;
        }

        .terms-of-use {
            display: flex;
            align-content: center;
            align-items: center;
        }
        .terms-of-use checkbox-field{
            margin-right : .325rem;
        }
    `]
})
export class TermsOfUseCheckboxComponent implements OnInit {

    @Input()
    public hotelQuote?: IQuote;

    @Input()
    public skipEpsCheck: boolean = false;

    @Input()
    public isTermsOfUseAccepted: boolean;
    @Output()
    public readonly isTermsOfUseAcceptedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public readonly btnStyleTypes: typeof BtnStyleTypes = BtnStyleTypes;

    public readonly checkboxControlName: string = 'checkbox';
    public readonly formGroup: FormGroup = new FormGroup({[this.checkboxControlName]: new FormControl()});
    public readonly checkboxFieldConfig: ICheckboxFieldSpecs = {
        formControlName: this.checkboxControlName,
        formGroup: this.formGroup,
        checkboxLabel: Yii.t('wui-shared-js', "J'ai lu et j'accepte les conditions d'utilisation d'Expedia")
    };

    public isTermsOfUseShown: boolean = false;

    constructor(private readonly permissionResourceService: PermissionResourceService) {
    }

    public ngOnInit(): void {
        this.permissionResourceService.hasPermission(IaqoboHotelPermission.IQBH_TERMSOFUSE_SHOW)
            .pipe(filter((hasPermission: boolean): boolean => hasPermission))
            .subscribe({
                next: (): void => {
                    if (this.hotelQuote?.host === 'EXPEDIA' || this.skipEpsCheck) {
                        this.isTermsOfUseShown = true;
                        this.updateAcceptation(false);
                    }
                }
            });
    }

    public updateAcceptation(acceptation: boolean): void {
        this.isTermsOfUseAcceptedChange.emit(acceptation);
    }

    public goToUrl(): void {
        window.open("https://developer.expediapartnersolutions.com/terms/agent/fr-ca", "_blank");
    }
}
